export default __webpack_public_path__ + "static/media/learning-notification-icon.da1931ab.svg";